//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
import User from "../../store/models/User";
import SessionStorage from 'quasar/src/plugins/SessionStorage.js';;
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog
  },
  props: {
    user: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      email: null,
      password: null
    };
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.email === this.me.email) {
        this.$q.notify({
          message: this.$t('components.addUserDialog.already_logged_in'),
          type: 'warning'
        });
      } else {
        this.showLoading();
        User.$login({
          email: this.email,
          password: this.password
        }).then(function () {
          SessionStorage.clear();

          _this.hideLoading();

          window.location.reload();
        }).catch(function () {
          _this.hideLoading();

          _this.$q.notify({
            message: _this.$t('components.addUserDialog.incorect_login'),
            type: 'negative'
          });
        });
      }
    }
  },
  created: function created() {
    if (this.user) {
      this.email = this.user.email;
    }
  }
};